import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';

import authentication from '../../B2CAuth';
import logComponent from '../../common/logComponent';
import Loading from '../Loading/Loading';

export default function Login() {
  const [signedIn, setSignedIn] = useState(false);
  if (logComponent('Login')) { console.debug('Login rendered'); }

  useEffect(() => {
    authentication.logIn(() => {
      setSignedIn(true);
    });
  }, [])

  if (signedIn) {
    return (<Navigate to="/" />);
  }
  return (<Loading />);
}
